module.exports = __webpack_public_path__ + "static/media/salt.69b96fbc.svg";